<div class="indikaattori">
  <span class="indikaattorin-teksti">
    <strong>Suodatus:</strong> {{ suodatus().kuvaus }} · {{ suodatus().rivinNimi }} — {{ asiakkaita() === 1 ? '1 asiakas' : asiakkaita() + ' asiakasta' }}
  </span>
  <span class="poistonappi" role="button" tabindex="0" title="Poista suodatus" aria-label="Poista suodatus" (click)="poista.emit()" (keydown.enter)="poista.emit()">✕</span>
</div>
